<template>
  <div class="home">
		<PageHeader></PageHeader>
		<PageSwiper @showMask="openMask"></PageSwiper>
		<PageMain @showMask="openMask"></PageMain>
		<div class="popup" v-show="isShow&&!close">
			<div class="popup-wrap">
				<div class="left">
					<img class="logo" src="../assets/images/logo.png" alt="陌陌回收logo">
					<div>
						<span class="text">陌陌回收 -- 一个让您买得舒心的平台</span>
					</div>
				</div>
				<div class="right">
					<div class="download">
						<img class="EQ-img" src="../assets/images/QR_android.png" alt="Android下载二维码">
						<p>Android下载</p>
					</div>
				</div>
			</div>
			<div class="icon" @click="close = true">
				<i class="el-icon-close"></i>
			</div>
		</div>
		
		<div class="mask" v-show="showMask">
			<div class="mask-wrap">
				<div class="download-box">
					<div class="down-item" v-for="(item,index) in downList" :key="index">
						<img :src="item.QRImg" :alt="item.title+'二维码'">
						<h4 style="margin: 10px 0;">{{item.title}}</h4>
						<p>{{item.text}}</p>
					</div>
				</div>
				<div class="popup-close" @click="closeMask"></div>
			</div>
		</div>
		<PageFooter></PageFooter>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/head.vue'
import PageSwiper from '@/components/swiper.vue'
import PageMain from '@/components/main.vue'
import PageFooter from '@/components/footer.vue'
export default {
  name: 'Home',
	data(){
		return {
			isShow: false,
			close: false,
			showMask: false,
			downList: [
				{
					title: '陌陌回收公众号',
					text: '扫描二维码关注公众号',
					QRImg: require('../assets/images/wechat_QR.jpg')
				},
				{
					title: '下载陌陌回收',
					text: '扫描二维码免费下载',
					QRImg: require('../assets/images/QR_android.png')
				}
			]
		}
	},
	
  components: {
		PageHeader,
		PageSwiper,
		PageMain,
		PageFooter
  },
	
	methods:{
		handleScroll(){
			if (!!document.documentElement.scrollTop && document.documentElement.scrollTop > 500 && document.documentElement.scrollTop + document.documentElement.clientHeight < document.body.scrollHeight - 200) {
				this.isShow = true
			} else {
				this.isShow = false
			}
		},
		
		openMask(){
			this.showMask = true
		},
		
		closeMask(){
			this.showMask = false
		}
	},
	
	mounted() {
		window.addEventListener('scroll',this.handleScroll)
	}
}
</script>

<style scoped>

.popup{
	width: 100%;
	min-width: 1226px;
	height: 150px;
	background-color: rgba(255,255,255,.9);
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 999;
}

.popup .icon{
	position: absolute;
	right: 100px;
	top: 50%;
	transform: translateY(-50%);
	font-size: 46px;
	color: #999;
	cursor: pointer;
}

.popup-wrap{
	width: 1226px;
	height: 150px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.popup-wrap .left{
	display: flex;
	align-items: center;
}

.logo{
	width: 110px;
	height: 110px;
}

.text{
	font-size: 36px;
	font-weight: bold;
	color: #3c78eb;
	margin-left: 100px;
}

.popup-wrap .right{
	display: flex;
	align-items: center;
}

.download{
	margin-left: 20px;
	text-align: center;
}

.download .EQ-img{
	width: 90px;
	height: 90px;
}

.download p{
	font-size: 14px;
	color: #282828;
	font-weight: bold;
}

.mask{
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(0,0,0,.6);
	z-index: 999;
}

.mask-wrap{
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
}

.download-box{
	background-color: #fff;
	display: flex;
	width: 548px;
	height: 320px;
	border-radius: 10px;
}

.download-box .down-item{
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.download-box .down-item:first-child{
	border-right: 1px solid #eee;
}

.download-box .down-item img{
	width: 168px;
	height: 168px;
}

.popup-close{
	width: 48px;
	height: 48px;
	background: url(../assets/images/close.png) no-repeat;
	background-size: 48px 48px;
	margin: 20px auto;
	cursor: pointer;
}
</style>